import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box, Button } from '@mui/material';
import fileDownload from 'js-file-download';
import { getDetailData } from '../utils/detail/DetailInterface';
import { wrapperCall } from '../utils/utils';
import Grid from '../components/Grid';


function DetailPage(props) {
    const [rowData, setRowData] = useState();
    const [columnDefs, setColumnDefs]  = useState();
    const [noData, setNoData] = useState(false);
    const token = useSelector(state => state.auth.token);
    const info = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        getDetailData(token, info, setRowData, setColumnDefs, setNoData, navigate);
    }, []);

    const handleExportToExcel = async (event) => {
        event.preventDefault();
        const response = await wrapperCall('new/detail/exporttoexcel', info, token, 'blob', navigate);
        const filename = response.headers['file-name'];
        fileDownload(response.data, filename);
    }

    return (
        <>
           { !noData && rowData && <Box>
                <Box className="table">
                    <Grid rowData={rowData} columnDefs={columnDefs} />
                </Box>
                <Box sx={{ display: 'flex', gap: '20px', position:"relative", left:"60%", width:"40%" }}>
                    <Button
                        className="buttons"
                        type="submit"
                        variant="outlined"
                        color="inherit"
                        sx={{ color: 'white', backgroundColor: 'red', '&:hover': { backgroundColor: '#8b0000' }}}
                        onClick={handleExportToExcel}
                    >
                        Export to Excel
                    </Button>
                </Box>
            </Box> }
            { noData && <p style={{ color: "red", textAlign: "center" }}>No data available.</p> }
        </>
    );
}

export default DetailPage;